/* 孫吳傳・第 18 章：夷陵（222 年）
 * 一條長長的山谷由東往西，蜀軍沿著谷道連營數百里（這裡是八座營）；江在南邊。東邊是陸遜的吳營，西邊盡頭是劉備的大營。
 * 吳營前有一條「不出擊」的界線。 */
export const CAMPS = [[7600, 1950], [6800, 2150], [6000, 1950], [5200, 2150], [4400, 1950], [3600, 2150], [2800, 1950], [2000, 2150]];
export const WU = [9300, 2050], LIUBEI = [900, 2050], HOLD_X = 8350;
export default {
  id: 'yiling', name: '夷陵', W: 10200, H: 4400, seed: 222,
  bases: [WU, LIUBEI],
  rivers: [{ pts: [[-100, 3700], [3000, 3650], [6000, 3720], [10300, 3660]], hw: 300, fords: [] }],
  roads: [{ pts: [WU, [8400, 2050], ...CAMPS, LIUBEI], w: 150 }],
  rocks: [[3200, 900, 420, 200], [6400, 900, 420, 200], [8800, 1000, 400, 200], [1500, 3000, 320, 160], [5800, 3000, 320, 160]],
  woods: 0.6,
  sight: 0.75,
  clearings: [[WU[0], WU[1], 600], [LIUBEI[0], LIUBEI[1], 600], ...CAMPS.map(([x, y]) => [x, y, 340])],
  tents: [{ x: WU[0], y: WU[1], n: 8, r: 460, chief: true, col: '#b8433a', flag: '陸' }, { x: LIUBEI[0], y: LIUBEI[1], n: 8, r: 460, chief: true, col: '#3e7b50', flag: '漢' },
    ...CAMPS.map(([x, y]) => ({ x, y, n: 4, r: 240, col: '#3e7b50' }))],
};
